export const SHOPIFY_RATE_LINK =
  "https://apps.shopify.com/alidrop-aliexpress-dropship-1/reviews?ratings%5B%5D=5#modal-show=WriteReviewModal";
